// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"ec4cf478","777":"08a89556"}[chunkId] + ".chunk.js");